import "../chunk-D57E6H3M.mjs";

// src/hooks/useLoadingActivity.ts
import { createContext, use, useEffect } from "react";
var LoadingActivityContext = createContext(null);
function useReportLoading(active = true) {
  const report = use(LoadingActivityContext);
  useEffect(() => active && report ? report() : void 0, [active, report]);
}
export {
  LoadingActivityContext,
  useReportLoading
};
//# sourceMappingURL=useLoadingActivity.mjs.map